module.exports = __webpack_public_path__ + "static/MailSculpt-Blog-1-25b98eefdc226a5e5ecf8cd4abbcdc92.png";